import { AlignType } from "../../Controls/ControlEnums";
import { BaseAlignElement } from "./BaseAlignElement";

export class AlignPanelValidation {
    /**
     * Zvaliduje panel a vrati informaci zda se bude dokovat, pozicovat a nebo neni validni
     * @param panel
     */
    public static validate(panel: BaseAlignElement): AlignValidationResult {
        if (!AlignPanelValidation._hasValidDockAttrs(panel))
            return AlignValidationResult.invalid;
        const children = panel.element ? Array.from(panel.element.children) as HTMLElement[] : [];

        let res = AlignValidationResult.invalid;

        for (const child of children) {
            const result = AlignPanelValidation._validateInnerElement(child);
            if (result === AlignValidationResult.invalid)
                child.remove();
            else if (res === AlignValidationResult.invalid) {
                res = result;
            }
        }

        return res;
    }

    private static _validateInnerElement(element: HTMLElement): AlignValidationResult {
        if (!(element instanceof HTMLElement))
            return AlignValidationResult.invalid;

        const tempEl = new BaseAlignElement(element);
        if (AlignPanelValidation._isValidDockingElement(tempEl, true)) {
            return AlignValidationResult.docking;
        } else {
            return AlignPanelValidation._hasValidPosAttr(tempEl) ? AlignValidationResult.positioning : AlignValidationResult.invalid;
        }
    }

    /** Overi, zda dokovaci element ma v poradku rozmerove atributy */
    private static _hasValidDockAttrs(panel: BaseAlignElement): boolean {
        return (
            ((panel.alignType === AlignType.bottom || panel.alignType === AlignType.top) && panel.height > 0) ||
                ((panel.alignType === AlignType.left || panel.alignType === AlignType.right) && panel.width > 0) ||
                panel.alignType === AlignType.client //alClient nevyzaduje atributy
        );
    }

    public static isDockingElement(element: BaseAlignElement): boolean {
        return AlignPanelValidation._isValidDockingElement(element);
    }

    /** Overi, zda je podle data-align atributu dany element urcen k dokovani; druhy atribut urcuje, zda se maji kontrolovat i atributy s rozmery elementu */
    private static _isValidDockingElement(element: BaseAlignElement, validateDimensions: boolean = false): boolean {
        if (element.alignType !== AlignType.none) {
            //element je dokovaci
            if (validateDimensions) {
                return AlignPanelValidation._hasValidDockAttrs(element);
            } else {
                return true;
            }
        }
        return false;
    }

    /** Overi, zda je podle data-align atributu dany element urcen k pozicovani (nebo atribut nema) */
    private static _hasValidPosAttr(element: BaseAlignElement): boolean {
        return element.alignType === AlignType.none;
    }
}

export enum AlignValidationResult {
    docking,
    positioning,
    invalid,
}
